import React from 'react';
import { Phone, ArrowRight, Check } from 'lucide-react';
import { business, freedomImage } from '../mock';

const points = [
  'Enjoy quality time with your aging family members without the pressures of caregiving.',
  'Catch up on important tasks that have been on hold.',
  'Be fully present for your kids and family.',
  'Take that much-needed vacation to combat burnout and be your best self.',
];

export default function FreedomSection({ onSchedule }) {
  return (
    <section className="section" style={{ backgroundColor: 'var(--cream)' }} data-testid="freedom-section">
      <div className="container-x">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="reveal order-2 lg:order-1">
            <p className="eyebrow mb-2">Serving the Dallas &ndash; Ft. Worth Metroplex</p>
            <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}>
              Freedom from constant worry about your loved one
            </h2>
            <ul className="mt-8 flex flex-col gap-4">
              {points.map((p) => (
                <li key={p} className="flex items-start gap-3.5">
                  <span className="flex items-center justify-center rounded-full mt-0.5 shrink-0" style={{ width: 26, height: 26, backgroundColor: 'var(--sage)' }}>
                    <Check size={15} style={{ color: 'var(--forest)' }} strokeWidth={3} />
                  </span>
                  <span className="text-[16px]" style={{ color: 'var(--ink)' }}>{p}</span>
                </li>
              ))}
            </ul>
            <p className="mt-7 text-[16px]" style={{ color: 'var(--muted)' }}>
              The reality is you can&rsquo;t be there for everyone all the time, all by yourself &mdash;
              and with us, you don&rsquo;t have to be. Mom&rsquo;s Best Friend Senior Care is here for you.
            </p>
            <div className="flex flex-wrap gap-4 mt-8">
              <button className="btn-sage" onClick={onSchedule} data-testid="freedom-schedule-btn">
                Schedule a Consultation <ArrowRight size={18} />
              </button>
              <a href={business.phoneHref} className="btn-outline" data-testid="freedom-call-btn">
                <Phone size={18} /> {business.phone}
              </a>
            </div>
          </div>

          <div className="reveal order-1 lg:order-2">
            <div className="rounded-[28px] overflow-hidden" style={{ boxShadow: '0 30px 60px -30px rgba(30,59,44,0.4)' }}>
              <img src={freedomImage} alt="Family enjoying peace of mind with in-home senior care" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
